import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const updateStations = (
  state: StationsState,
  action: PayloadAction<StationsState['stations']['data']>
) => {
  state.stations.data = action.payload
};
